var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section is-main-section"},[_c('h2',[_vm._v("Traffic Chart")]),_c('dashboard-traffic-chart')],1)}
var staticRenderFns = []

export { render, staticRenderFns }